// extracted by mini-css-extract-plugin
module.exports = {"nextPrevButton":"NextPrevButton_nextPrevButton__s0tuK","icon":"NextPrevButton_icon__iu_ND"};